import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  backdrop: false,
  transactionIndividual: [],
  inventoryIndividual: [],
};

export const sellerhubSlice = createSlice({
  name: "sellerhub",
  initialState,
  reducers: {
    openBackdropWithoutData: (state) => {
      return {
        ...state,
        backdrop: true,
      };
    },
    openBackdropWithDataWallet: (state, action) => {
      return {
        ...state,
        backdrop: true,
        transactionIndividual: [action.payload],
      };
    },

    openBackdropWithDataInventory: (state, action) => {
      return {
        ...state,
        backdrop: true,
        inventoryIndividual: [action.payload],
      };
    },
    closeBackdrop: (state) => {
      return {
        ...state,
        backdrop: false,
        transactionIndividual: [],
        inventoryIndividual: [],
      };
    },
  },
});

export const {
  openBackdropWithDataWallet,
  openBackdropWithDataInventory,
  openBackdropWithoutData,
  closeBackdrop,
} = sellerhubSlice.actions;
export default sellerhubSlice.reducer;
